// https://github.com/diegohaz/arc/wiki/Example-components#icon
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  margin: 0.1em;
  box-sizing: border-box;
`;

const Image = ({ icon, alt, ...props }) => {
  const src = `/assets/${icon}.png`;
  return (
    <Wrapper {...props}>
      <img alt={alt} src={src} />
    </Wrapper>
  );
};

Image.propTypes = {
  icon: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.string,
  alt: PropTypes.string,
  reverse: PropTypes.bool,
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Atoms/Image/index.js